import { atomWithStorage, createJSONStorage } from "jotai/utils";

import type { Language } from "../constants/language";
import { LANGUAGE_KEYS } from "../constants/language";

export const isSupportedLanguage = (lang: string): lang is Language =>
	(LANGUAGE_KEYS as readonly string[]).includes(lang);

export const getUserPreferredLanguage = () => {
	const language = window.navigator.language;
	const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
	return isSupportedLanguage(languageWithoutRegionCode)
		? languageWithoutRegionCode
		: "en";
};

export const languageAtom = atomWithStorage<Language>(
	"language",
	getUserPreferredLanguage(),
	createJSONStorage(() => localStorage),
	{ getOnInit: true }, // prefers local storage over default value
);

languageAtom.debugLabel = "languageAtom";
